import React from "react";

export default function Conditiongeneral() {
  return (
    <section className="max-w-5xl mx-auto px-6 py-16 text-sm leading-relaxed">
      <h1 className="text-3xl font-bold mb-6">Conditions générales de vente</h1>

      <div className="space-y-8">
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 1 - CONDITIONS D'UTILISATION DE LA BOUTIQUE EN LIGNE
          </h2>
          <p>
            En acceptant ces conditions d'utilisation, vous déclarez que vous
            avez au moins l'âge de la majorité dans votre état ou province de
            résidence, et que vous nous avez donné votre consentement pour
            permettre à l'un de vos mineurs à charge d'utiliser ce site. Vous ne
            pouvez pas utiliser nos produits à des fins illégales ou non
            autorisées et vous ne pouvez pas, dans le cadre de l'utilisation du
            Service, violer les lois de votre juridiction (y compris, mais sans
            s'y limiter, les lois sur les droits d'auteur). Vous ne devez pas
            transmettre de vers, de virus ou tout code de nature destructrice.
            Toute violation de l'une des présentes Conditions entraînera la
            résiliation immédiate de vos Services.
          </p>
        </div>

        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 2 - CONDITIONS GÉNÉRALES
          </h2>
          <p>
            Nous nous réservons le droit de refuser le service à quiconque, pour
            quelque raison que ce soit et à tout moment. Vous comprenez que
            votre contenu (à l'exclusion des informations de carte de crédit)
            peut être transféré de manière non chiffrée et impliquer (a) des
            transmissions sur divers réseaux ; et (b) des modifications pour se
            conformer et s'adapter aux exigences techniques de connexion des
            réseaux ou des appareils. Les informations de carte de crédit sont
            toujours chiffrées pendant le transfert sur les réseaux. Vous
            acceptez de ne pas reproduire, dupliquer, copier, vendre, revendre
            ou exploiter toute partie du Service, l'utilisation du Service, ou
            l'accès au Service ou tout contact sur le site Web par lequel le
            service est fourni, sans autorisation écrite expresse de notre part.
            Les titres utilisés dans le présent accord sont inclus uniquement
            pour des raisons de commodité et ne limiteront ni n'affecteront
            autrement ces conditions.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 3 - EXACTITUDE, EXHAUSTIVITÉ ET ACTUALITÉ DES INFORMATIONS
          </h2>
          <p>
            Nous ne sommes pas responsables si les informations mises à
            disposition sur ce site ne sont pas exactes, complètes ou à jour. Le
            contenu de ce site est fourni à titre d'information générale
            uniquement et ne doit pas être utilisé comme seule base pour prendre
            des décisions sans consulter des sources d'information primaires,
            plus précises, plus complètes ou plus actuelles. Toute utilisation
            du contenu de ce site relève de votre propre responsabilité. Ce site
            peut contenir certaines informations historiques. Ces informations
            historiques ne sont pas nécessairement à jour et sont fournies à
            titre indicatif uniquement. Nous nous réservons le droit de modifier
            le contenu de ce site à tout moment, mais nous n'avons aucune
            obligation de mettre à jour les informations sur notre site. Vous
            acceptez qu'il est de votre responsabilité de surveiller les
            modifications apportées à notre site.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 4 - MODIFICATIONS APPORTÉES AU SERVICE ET AUX PRIX
          </h2>
          <p>
            Les prix de nos produits sont sujets à changement sans préavis. Nous
            nous réservons le droit de modifier ou d'interrompre le Service (ou
            toute partie ou contenu de celui-ci) à tout moment et sans préavis.
            Nous ne serons pas responsables envers vous ou envers un tiers de
            toute modification, changement de prix, suspension ou interruption
            du Service.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 5 - PRODUITS OU SERVICES
          </h2>
          <p>
            Certains produits ou services peuvent être disponibles exclusivement
            en ligne sur le site Web. Ces produits ou services peuvent être
            disponibles en quantités limitées et ne peuvent être retournés ou
            échangés que conformément à notre politique de retour. Nous avons
            fait de notre mieux pour afficher aussi précisément que possible les
            couleurs et les images de nos produits qui apparaissent dans notre
            boutique. Nous ne pouvons pas garantir que l'affichage des couleurs
            sur votre écran d'ordinateur sera précis. Nous nous réservons le
            droit, sans toutefois y être obligés, de limiter les ventes de nos
            produits ou services à toute personne, région géographique ou
            juridiction. Nous pouvons exercer ce droit au cas par cas. Nous nous
            réservons le droit de limiter les quantités de tout produit ou
            service que nous proposons. Toutes les descriptions de produits ou
            les prix des produits sont susceptibles d'être modifiés à tout
            moment sans préavis, à notre seule discrétion. Nous nous réservons
            le droit d'interrompre la production de tout produit à tout moment.
            Toute offre de produit ou de service faite sur ce site est nulle là
            où la loi l'interdit. Nous ne garantissons pas que la qualité des
            produits, services, informations ou autres matériels achetés ou
            obtenus par vous répondra à vos attentes, ni que les erreurs dans le
            Service seront corrigées.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 6 - EXACTITUDE DES INFORMATIONS DE FACTURATION ET DE COMPTE
          </h2>
          <p>
            Nous nous réservons le droit de refuser toute commande que vous
            passez auprès de nous. Nous pouvons, à notre seule discrétion,
            limiter ou annuler les quantités achetées par personne, par foyer ou
            par commande. Ces restrictions peuvent inclure des commandes passées
            par ou sous le même compte client, la même carte de crédit et/ou des
            commandes qui utilisent la même adresse de facturation et/ou de
            livraison. Dans le cas où nous modifions ou annulons une commande,
            nous pouvons tenter de vous avertir en vous contactant à l'adresse
            e-mail et/ou à l'adresse de facturation/au numéro de téléphone
            fournis au moment de la commande. Nous nous réservons le droit de
            limiter ou d'interdire les commandes qui, à notre seul jugement,
            semblent être passées par des revendeurs ou des distributeurs. Vous
            acceptez de fournir des informations d'achat et de compte à jour,
            complètes et exactes pour tous les achats effectués dans notre
            boutique. Vous acceptez de mettre à jour rapidement votre compte et
            vos autres informations, y compris votre adresse e-mail, vos numéros
            de carte de crédit et leurs dates d'expiration, afin que nous
            puissions finaliser vos transactions et vous contacter si
            nécessaire. Pour plus de détails, veuillez consulter notre politique
            de retour.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 7 - OUTILS OPTIONNELS
          </h2>
          <p>
            Nous pouvons vous fournir l'accès à des outils tiers sur lesquels
            nous n'exerçons aucun contrôle ni aucune influence. Vous
            reconnaissez et acceptez que nous fournissons l'accès à ces outils «
            tels quels » et « tels que disponibles » sans aucune garantie,
            représentation ou condition d'aucune sorte et sans aucune
            approbation. Nous déclinons toute responsabilité découlant de votre
            utilisation d'outils tiers facultatifs ou en rapport avec celle-ci.
            Toute utilisation par vous des outils optionnels proposés via le
            site est entièrement à vos propres risques et à votre propre
            discrétion et vous devez vous assurer que vous connaissez et
            approuvez les conditions dans lesquelles les outils sont fournis par
            le(s) fournisseur(s) tiers concerné(s). Nous pourrons également, à
            l'avenir, proposer de nouveaux services et/ou fonctionnalités via le
            site Web (y compris la mise à disposition de nouveaux outils et
            ressources). Ces nouvelles fonctionnalités et/ou services seront
            également soumis aux présentes Conditions d'utilisation.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 8 - LIENS DE TIERS
          </h2>
          <p>
            Certains contenus, produits et services disponibles via notre
            Service peuvent inclure des éléments provenant de tiers. Les liens
            de tiers sur ce site peuvent vous rediriger vers des sites Web tiers
            qui ne sont pas affiliés à nous. Nous ne sommes pas responsables de
            l'examen ou de l'évaluation du contenu ou de l'exactitude et nous ne
            garantissons pas et n'assumons aucune responsabilité pour tout
            matériel ou site Web tiers, ou pour tout autre matériel, produit ou
            service de tiers. Nous ne sommes pas responsables des préjudices ou
            dommages liés à l'achat ou à l'utilisation de biens, de services, de
            ressources, de contenu ou de toute autre transaction effectuée en
            rapport avec des sites Web tiers. Veuillez examiner attentivement
            les politiques et pratiques des tiers et assurez-vous de les
            comprendre avant de vous engager dans une transaction. Les plaintes,
            réclamations, préoccupations ou questions concernant les produits
            tiers doivent être adressées au tiers.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 9 - COMMENTAIRES ET AUTRES SOUMISSIONS DES UTILISATEURS
          </h2>
          <p>
            Si, à notre demande, vous nous envoyez des contributions spécifiques
            (par exemple des participations à des concours) ou si, sans demande
            de notre part, vous nous envoyez des idées créatives, des
            suggestions, des propositions, des plans ou d'autres éléments, que
            ce soit en ligne, par courrier électronique, par courrier postal ou
            autrement (collectivement, les « commentaires »), vous acceptez que
            nous puissions, à tout moment, sans restriction, éditer, copier,
            publier, distribuer, traduire et utiliser de toute autre manière sur
            tout support les commentaires que vous nous transmettez. Nous ne
            sommes et ne serons pas tenus (1) de maintenir la confidentialité
            des commentaires ; (2) de payer une compensation pour les
            commentaires ; ou (3) de répondre aux commentaires. Nous pouvons,
            mais n'avons aucune obligation de, surveiller, modifier ou supprimer
            le contenu que nous déterminons, à notre seule discrétion, comme
            étant illégal, offensant, menaçant, diffamatoire, pornographique,
            obscène ou autrement répréhensible ou qui viole la propriété
            intellectuelle d'une partie ou les présentes conditions
            d'utilisation. Vous acceptez que vos commentaires ne violent aucun
            droit de tiers, y compris les droits d'auteur, les marques déposées,
            la confidentialité, la personnalité ou tout autre droit personnel ou
            de propriété. Vous acceptez en outre que vos commentaires ne
            contiennent pas de contenu diffamatoire ou autrement illégal, abusif
            ou obscène, ni de virus informatique ou autre logiciel malveillant
            qui pourrait de quelque manière que ce soit affecter le
            fonctionnement du Service ou de tout site Web associé. Vous ne
            pouvez pas utiliser une fausse adresse e-mail, prétendre être
            quelqu'un d'autre que vous-même ou induire en erreur nous ou des
            tiers quant à l'origine de tout commentaire. Vous êtes seul
            responsable de tous les commentaires que vous faites et de leur
            exactitude. Nous déclinons toute responsabilité et déclinons toute
            responsabilité pour tout commentaire publié par vous ou par un
            tiers.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 10 - RENSEIGNEMENTS PERSONNELS
          </h2>
          <p>
            Votre soumission d'informations personnelles via la boutique est
            régie par notre politique de confidentialité.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 11 - ERREURS, INEXACTITUDES ET OMISSIONS
          </h2>
          <p>
            Il est possible que des informations sur notre site ou dans le
            Service contiennent des erreurs typographiques, des inexactitudes ou
            des omissions pouvant concerner les descriptions de produits, les
            prix, les promotions, les offres, les frais d'expédition des
            produits, les délais de livraison et la disponibilité. Nous nous
            réservons le droit de corriger toute erreur, inexactitude ou
            omission, et de modifier ou de mettre à jour les informations ou
            d'annuler les commandes si des informations dans le Service ou sur
            tout site Web associé sont inexactes à tout moment sans préavis (y
            compris après avoir soumis votre commande). Nous ne sommes pas tenus
            de mettre à jour, de modifier ou de clarifier les informations
            contenues dans le Service ou sur tout site Web associé, y compris,
            sans limitation, les informations sur les prix, sauf si la loi
            l'exige. Aucune date de mise à jour ou d'actualisation spécifiée
            appliquée dans le Service ou sur tout site Web associé ne doit être
            considérée comme indiquant que toutes les informations du Service ou
            sur tout site Web associé ont été modifiées ou mises à jour.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 12 - UTILISATIONS INTERDITES
          </h2>
          <p>
            Français, en plus des autres interdictions énoncées dans les
            Conditions d'utilisation, il vous est interdit d'utiliser le site ou
            son contenu : (a) à des fins illégales ; (b) pour inciter d'autres
            personnes à accomplir ou à participer à des actes illégaux ; (c)
            pour violer toute réglementation, règle, loi ou ordonnance locale
            internationale, fédérale, provinciale ou étatique ; (d) pour
            enfreindre ou violer nos droits de propriété intellectuelle ou les
            droits de propriété intellectuelle d'autrui ; (e) pour harceler,
            abuser, insulter, nuire, diffamer, calomnier, dénigrer, intimider ou
            discriminer en fonction du sexe, de l'orientation sexuelle, de la
            religion, de l'origine ethnique, de la race, de l'âge, de l'origine
            nationale ou du handicap ; (f) pour soumettre des informations
            fausses ou trompeuses ; (g) pour télécharger ou transmettre des
            virus ou tout autre type de code malveillant qui sera ou pourrait
            être utilisé de quelque manière que ce soit qui affectera la
            fonctionnalité ou le fonctionnement du Service ou de tout site Web
            associé, d'autres sites Web ou d'Internet ; (h) pour collecter ou
            suivre les informations personnelles d'autrui ; (i) pour spammer,
            hameçonner, détourner un domaine, extorquer, spider, crawler ou
            scraper ; (j) à des fins obscènes ou immorales ; ou (k) pour
            interférer avec ou contourner les fonctionnalités de sécurité du
            Service ou de tout site Web associé, d'autres sites Web ou
            d'Internet. Nous nous réservons le droit de mettre fin à votre
            utilisation du Service ou de tout site Web associé pour violation de
            l'une des utilisations interdites.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 13 - EXCLUSION DE GARANTIES ; LIMITATION DE RESPONSABILITÉ
          </h2>
          <p>
            Nous ne garantissons pas que votre utilisation de notre service sera
            ininterrompue, rapide, sécurisée ou sans erreur. Nous ne
            garantissons pas que les résultats qui peuvent être obtenus à partir
            de l'utilisation du service seront exacts ou fiables. Vous acceptez
            que nous puissions de temps à autre supprimer le service pour des
            périodes indéterminées ou annuler le service à tout moment, sans
            préavis. Vous acceptez expressément que votre utilisation du service
            ou votre incapacité à l'utiliser est à vos seuls risques et périls.
            Le service et tous les produits et services qui vous sont fournis
            via le service sont (sauf mention expresse de notre part) fournis «
            tels quels » et « tels que disponibles » pour votre utilisation,
            sans aucune représentation, garantie ou condition d'aucune sorte,
            expresse ou implicite, y compris toutes les garanties ou conditions
            implicites de qualité marchande, d'adéquation à un usage
            particulier, de durabilité, de titre et de non-contrefaçon. En aucun
            cas SAME, nos directeurs, dirigeants, employés, sociétés affiliées,
            agents, entrepreneurs, stagiaires, fournisseurs, prestataires de
            services ou concédants de licence ne peuvent être tenus responsables
            de toute blessure, perte, réclamation ou de dommages directs,
            indirects, accessoires, punitifs, spéciaux ou consécutifs de quelque
            nature que ce soit, y compris, sans limitation, la perte de profits,
            la perte de revenus, la perte d'économies, la perte de données, les
            coûts de remplacement ou tout dommage similaire, qu'il soit fondé
            sur un contrat, un délit (y compris la négligence), une
            responsabilité stricte ou autre, découlant de votre utilisation de
            tout service ou produit provenant de ce Service, ou pour toute autre
            réclamation liée de quelque manière que ce soit à votre utilisation
            du Service ou de tout produit, y compris, mais sans s'y limiter,
            toute erreur ou omission dans tout contenu, ou toute perte ou tout
            dommage de toute sorte découlant de l'utilisation du Service ou de
            tout contenu (ou produit) publié, transmis ou autrement rendu
            disponible via le Service, même si vous avez été informé de leur
            possibilité. Étant donné que certains États ou juridictions
            n'autorisent pas l'exclusion ou la limitation de responsabilité pour
            les dommages indirects ou accessoires, dans ces États ou
            juridictions, notre responsabilité sera limitée dans la mesure
            maximale autorisée par la loi.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 14 - INDEMNISATION
          </h2>
          <p>
            Vous acceptez d'indemniser, de défendre et de dégager de toute
            responsabilité SAME et notre société mère, nos filiales, sociétés
            affiliées, partenaires, dirigeants, administrateurs, agents,
            sous-traitants, concédants de licence, prestataires de services,
            sous-traitants, fournisseurs, stagiaires et employés, de toute
            réclamation ou demande, y compris les honoraires raisonnables
            d'avocat, faite par un tiers en raison ou découlant de votre
            violation des présentes conditions de service ou des documents
            qu'elles incorporent par référence, ou de votre violation de toute
            loi ou des droits d'un tiers.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 15 - DIVISIBILITÉ
          </h2>
          <p>
            Dans le cas où une disposition des présentes Conditions
            d'utilisation serait jugée illégale, nulle ou inapplicable, cette
            disposition sera néanmoins applicable dans toute la mesure permise
            par la loi applicable, et la partie inapplicable sera réputée être
            séparée des présentes Conditions d'utilisation, cette détermination
            n'affectera pas la validité et l'applicabilité de toute autre
            disposition restante.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 16 - RÉSILIATION
          </h2>
          <p>
            Les obligations et responsabilités des parties engagées avant la
            date de résiliation survivront à la résiliation du présent accord à
            toutes fins. Les présentes Conditions d'utilisation sont en vigueur
            jusqu'à leur résiliation par vous ou par nous. Vous pouvez résilier
            les présentes Conditions d'utilisation à tout moment en nous
            informant que vous ne souhaitez plus utiliser nos Services ou
            lorsque vous cessez d'utiliser notre site. Si, à notre seule
            discrétion, vous ne parvenez pas, ou si nous soupçonnons que vous
            n'avez pas respecté une quelconque condition ou disposition des
            présentes Conditions d'utilisation, nous pouvons également résilier
            cet accord à tout moment sans préavis et vous resterez responsable
            de tous les montants dus jusqu'à la date de résiliation incluse ;
            et/ou nous pouvons en conséquence vous refuser l'accès à nos
            Services (ou à toute partie de ceux-ci).
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 17 - INTÉGRALITÉ DE L'ACCORD
          </h2>
          <p>
            Le fait que nous ne parvenions pas à exercer ou à appliquer un droit
            ou une disposition des présentes Conditions d'utilisation ne
            constitue pas une renonciation à ce droit ou à cette disposition.
            Les présentes Conditions d'utilisation et toutes les politiques ou
            règles de fonctionnement publiées par nous sur ce site ou concernant
            le Service constituent l'intégralité de l'accord et de l'entente
            entre vous et nous et régissent votre utilisation du Service,
            remplaçant tous les accords, communications et propositions
            antérieurs ou contemporains, qu'ils soient oraux ou écrits, entre
            vous et nous (y compris, mais sans s'y limiter, toutes les versions
            antérieures des Conditions d'utilisation). Toute ambiguïté dans
            l'interprétation des présentes Conditions d'utilisation ne doit pas
            être interprétée en défaveur du rédacteur.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 18 - LOI APPLICABLE
          </h2>
          <p>
            Les présentes conditions générales de service et tout accord séparé
            par lequel nous vous fournissons des services seront régis et
            interprétés conformément aux lois françaises. Notre adresse
            enregistrée (à des fins juridiques uniquement) est 1 ROUTE D'ETRECHY, 91730 CHAMARANDE
          </p>
        </div>

        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 19 - MODIFICATIONS APPORTÉES AUX CONDITIONS GÉNÉRALES DE
            VENTE
          </h2>
          <p>
            Vous pouvez consulter la version la plus récente des Conditions
            d'utilisation à tout moment sur cette page. Nous nous réservons le
            droit, à notre seule discrétion, de mettre à jour, de modifier ou de
            remplacer toute partie des présentes Conditions d'utilisation en
            publiant des mises à jour et des modifications sur notre site Web.
            Il est de votre responsabilité de consulter régulièrement notre site
            Web pour vous tenir au courant des modifications. Votre utilisation
            continue ou votre accès à notre site Web ou au Service après la
            publication de toute modification des présentes Conditions
            d'utilisation constitue une acceptation de ces modifications.
          </p>
        </div>

        <div>
          <h2 className="font-semibold text-lg mb-2">
            SECTION 20 - COORDONNÉES
          </h2>
          <p>
            Les questions concernant les conditions d'utilisation doivent nous
            être envoyées au 1 ROUTE D'ETRECHY, 91730 CHAMARANDE
          </p>
        </div>
      </div>
    </section>
  );
}
